import { createContext, useContext } from 'react';

const LoginManager = createContext({
  email: null,
  otpRequired: false,
});

LoginManager.displayName = 'LoginManager';

export const useLoginManager = () => {
  const loginManager = useContext(LoginManager);
  return loginManager;
};

export const LoginProvider = LoginManager.Provider;
